import { styled } from '@linaria/react';

export const Wrapper = styled.div`
    color: var(--text-color);

    display: flex;
    justify-content: space-between;
    align-items: center;
    box-shadow: 0 2px 6px 2px #ddd;
    height: 60px;
    padding: 0 1rem;
    width: 100%;

    @media print {
        display: none;
    }

    h1 {
        font-size: 1.5rem;
        font-weight: 200;
        margin: 0;
        position: relative;

        .sub-header {
            position: absolute;
            top: -7px;
            right: -29px;
            font-size: 1rem;
        }
    }
`;

export const LeftContentWrapper = styled.div`
    flex: 0 0 10%;
    max-width: 10%;
    display: flex;
    align-items: center;
    justify-content: flex-start;
`;

export const MiddleContentWrapper = styled.div`
    position: absolute;
    top: 12px;
    left: calc(50% - 150px);
`;



export const RightContentWrapper = styled.div`
    font-size: 0.8rem;
    font-weight: 400;
    display: flex;
    flex: 1 1 25%;
    max-width: 25%;
    justify-content: flex-end;
    align-items: center;
    gap: 0.5rem;
`;

export const LogoWrapper = styled.div`
    display: flex;
    align-items: center;

    a {
        text-decoration: none;
        color: inherit;
    }
`;

export const IconWrapper = styled.div`
    border-left: 1px solid var(--border-color);
    display: flex;
    height: 40px;
    padding: 0 10px;
    align-items: center;
    gap: 5px;

    &.no-border {
        border-left: 0;
    }

    &:first-child {
        border-left: 0;
    }
`;

export const SearchWrapper = styled.div`
    display: flex;
    align-items: center;
    margin-left: 2rem;
    flex: 1;
    max-width: 500px;
    gap: 0.5rem;
    position: relative;
`;

export const SearchForm = styled.form`
    display: flex;
    align-items: center;
    width: 100%;
    position: relative;
    gap: 0.25rem;
`;

export const SearchInput = styled.input`
    width: 100%;
    padding: 0.5rem 5rem 0.5rem 1rem;
    border: 1px solid var(--border-color);
    border-radius: 20px;
    font-size: 0.875rem;
    background: #f8f9fa;

    &:focus {
        outline: none;
        border-color: var(--primary-color);
        box-shadow: 0 0 0 2px rgba(25, 118, 210, 0.2);
    }

    &::placeholder {
        color: #6c757d;
    }
`;

export const SearchButton = styled.button`
    position: absolute;
    right: 38px;
    background: none;
    border: none;
    cursor: pointer;
    padding: 4px;
    color: #6c757d;

    &:hover {
        color: var(--primary-color);
    }

    svg {
        width: 16px;
        height: 16px;
    }
`;

export const SearchSettingsButton = styled.button`
    position: absolute;
    right: 8px;
    background: none;
    border: none;
    cursor: pointer;
    padding: 4px;
    color: #6c757d;
    transition: color 0.2s ease;

    &:hover,
    &.active {
        color: var(--primary-color);
    }

    svg {
        width: 18px;
        height: 18px;
    }
`;

export const SearchSettingsPanel = styled.div`
    position: absolute;
    top: 100%;
    left: 0;
    right: 0;
    margin-top: 0.5rem;
    background: white;
    border: 1px solid var(--border-color);
    border-radius: 8px;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
    padding: 1rem;
    z-index: 1000;
    display: flex;
    gap: 1.5rem;
`;

export const SettingsSection = styled.div`
    flex: 1;
    min-width: 0;
`;

export const SettingsSectionTitle = styled.div`
    font-weight: 600;
    font-size: 0.875rem;
    margin-bottom: 0.5rem;
    color: var(--text-color);
`;

export const SettingsCheckboxGroup = styled.div`
    display: flex;
    flex-direction: column;
    gap: 0.5rem;

    label {
        display: flex;
        align-items: center;
        gap: 0.5rem;
        font-size: 0.875rem;
        cursor: pointer;
        color: var(--text-color);

        &:hover {
            color: var(--primary-color);
        }

        input[type='checkbox'] {
            cursor: pointer;
        }
    }
`;

export const VersionWrapper = styled.div`
    font-weight: 400;
    font-size: 0.7rem;
    color: #6c757d;
    margin-top: 1.5rem;
`;
